import type { IUser } from '../../../models/pa-egna-ben/user.model';

export class UserApiModel {
  public id!: number;
  public phoneNumber!: string;
  public emailAddress!: string;
  public firstName!: string;
  public lastName!: string;

  public static mapToBusinessModel(apiModel: UserApiModel): IUser {
    return {
      id: apiModel.id,
      phoneNumber: apiModel.phoneNumber,
      emailAddress: apiModel.emailAddress,
      firstName: apiModel.firstName,
      lastName: apiModel.lastName,
    };
  }
}
